import { createFileRoute } from "@tanstack/react-router";
import { SilverPage, silverRatesQO } from "@/components/SilverPage";
import { buildAliasHead } from "@/lib/alias-routes";

const TITLE = "Today's Live Silver Rate in Hyderabad — 1 Tola & 10 Gram Price";
const DESC = "Live silver / chandi rate in Hyderabad today — per tola, per 10 gram, per gram & per kg. Hourly auto-update from international XAG spot + USD/PKR FX.";

export const Route = createFileRoute("/silver-rate-hyderabad-pakistan")({
  head: () => buildAliasHead({ title: TITLE, description: DESC, path: "/silver-rate-hyderabad-pakistan" }),
  loader: ({ context }) => context.queryClient.ensureQueryData(silverRatesQO),
  component: () => (
    <SilverPage
      country="pakistan"
      cityName="Hyderabad, Pakistan"
      title="Today's Live Chandi (Silver) Rate in Hyderabad, Pakistan"
      intro="Live silver rate in Hyderabad — recalculated every 10 minutes from international XAG spot price and today's USD/PKR rate. Per tola, per 10 gram, per gram and per kilogram."
    />
  ),
});
